const MIN_VALID_RATIO = 0.8;
const MAX_VALID_RATIO = 3;
const ELEVATED_ZOOM_THRESHOLD = 1.2;

/**
 * Desktop CSS-zoom heuristic for the oral-exam lobby welcome banner.
 *
 * Uses `outerWidth / innerWidth` (Chrome Ctrl+/- zoom), not `devicePixelRatio`
 * or `visualViewport.scale` (OS display scale).
 */
export function estimateBrowserCssZoom(outerWidth: number, innerWidth: number): boolean {
  if (innerWidth <= 0) return false;
  const ratio = outerWidth / innerWidth;
  if (ratio < MIN_VALID_RATIO || ratio > MAX_VALID_RATIO) return false;
  return ratio >= ELEVATED_ZOOM_THRESHOLD;
}
